export default __webpack_public_path__ + "static/media/ic-message.2e38e152.svg";